module.exports = __webpack_public_path__ + "img/text.01f436f9.png";